import { render, staticRenderFns } from "./FiscalPeriodsList.vue?vue&type=template&id=a9fa581e&"
import script from "./FiscalPeriodsList.vue?vue&type=script&lang=js&"
export * from "./FiscalPeriodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports